/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Load a manifest for compiling source files.
*
* @module @stdlib/utils-library-manifest
*
* @example
* var manifest = require( '@stdlib/utils-library-manifest' );
*
* var conf = manifest( './manifest.json', {} );
*/

// MODULES //

var manifest = require( './main.js' );


// EXPORTS //

module.exports = manifest;
